var React = require('react');

function SUndo18 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.07289,5.92052,3.63075,2.67838a.22262.22262,0,0,1,.37967.157V5.2381h8.41091A4.28069,4.28069,0,0,1,15.381,6.38357a4.41108,4.41108,0,0,1,1.45714,3.74486,4.60538,4.60538,0,0,1-4.61428,4.03467l-3.676-.02024a.44363.44363,0,0,1-.44443-.44362l-.01133-.752a.44361.44361,0,0,1,.44767-.44362h3.91485a2.92,2.92,0,0,0,2.72324-3.08833,2.68681,2.68681,0,0,0-2.73214-2.5581H4.01042V9.26062a.22262.22262,0,0,1-.37967.157L.07289,6.23462a.2202.2202,0,0,1,0-.3141Z","fill":"var(--iconFill, #464646)"}));
}

SUndo18.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SUndo18;

SUndo18.default = SUndo18;
